/**
 * Stactize.Portal.BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OriginatingMarketplace = 'Azure' | 'AWS' | 'Stripe' | 'Google';

export const OriginatingMarketplace = {
    Azure: 'Azure' as OriginatingMarketplace,
    Aws: 'AWS' as OriginatingMarketplace,
    Stripe: 'Stripe' as OriginatingMarketplace,
    Google: 'Google' as OriginatingMarketplace
};

